var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ib-dialog",
    {
      attrs: {
        id: "dialog-share",
        visible: _vm.visible,
        top: "8vh",
        "empty-header": "",
        width: "530px",
      },
      on: { close: _vm.closeDialog },
    },
    [
      _c("div", { staticClass: "text-center dialog-share-icon" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/img/illustrations/share-financials.svg"),
            alt: "",
          },
        }),
      ]),
      _c(
        "div",
        { staticClass: "text-center font-outfit-medium dialog-share-title" },
        [_vm._v(" " + _vm._s(_vm.title) + " ")]
      ),
      _c(
        "div",
        { staticClass: "form-wrapper" },
        [
          _c(
            "el-form",
            { ref: "form" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "text-center font-outfit-regular dialog-share-description",
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("dialogs.share.copyLinkAndShare")) + " "
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { staticClass: "label-outside" },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.shareLink,
                      placeholder: " ",
                      readonly: true,
                    },
                  }),
                  _c(
                    "a",
                    { staticClass: "copy-link", on: { click: _vm.doCopy } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("dialogs.share.copyLink")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }